import { type Framework } from '@toeverything/infra';

import { ServersService } from '../cloud/services/servers';
import { RecentDocsService } from '../quicksearch';
import { GlobalState } from '../storage';
import {
  WorkspaceFlavoursProvider,
  WorkspaceScope,
  WorkspaceService,
} from '../workspace';
import { CloudWorkspaceFlavoursProvider } from './impls/cloud';
import {
  LOCAL_WORKSPACE_LOCAL_STORAGE_KEY,
  LocalWorkspaceFlavoursProvider,
} from './impls/local';
import { HotSyncInitService } from './services/hot-sync-init';

export { base64ToUint8Array, uint8ArrayToBase64 } from './utils/base64';

export function configureBrowserWorkspaceFlavours(framework: Framework) {
  framework
    .impl(WorkspaceFlavoursProvider('LOCAL'), LocalWorkspaceFlavoursProvider)
    .impl(WorkspaceFlavoursProvider('CLOUD'), CloudWorkspaceFlavoursProvider, [
      GlobalState,
      ServersService,
    ])
    // sl-suoi.1.3: Hot Sync Init — inject recent docs after workspace start
    .scope(WorkspaceScope)
    .service(HotSyncInitService, [WorkspaceService, RecentDocsService]);
}

/**
 * a hack for directly add local workspace to workspace list
 * Used after copying sqlite database file to appdata folder
 */
export function _addLocalWorkspace(id: string) {
  const allWorkspaceIDs: string[] = JSON.parse(
    localStorage.getItem(LOCAL_WORKSPACE_LOCAL_STORAGE_KEY) ?? '[]'
  );
  allWorkspaceIDs.push(id);
  localStorage.setItem(
    LOCAL_WORKSPACE_LOCAL_STORAGE_KEY,
    JSON.stringify(allWorkspaceIDs)
  );
}
